import ContentRemovalPolicyComp from "./components/content_removal_policy_comp";
import PageV2Comp from "../../components/page_v2/page_v2_comp";

const ContentRemovalPolicyPage = () => {
    return (
        <PageV2Comp showFooter={false}>
            <ContentRemovalPolicyComp />
        </PageV2Comp>
    );
};

export default ContentRemovalPolicyPage; 